var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.643 2.93695C22.808 3.30695 21.911 3.55696 20.968 3.66996C21.941 3.08775 22.669 2.17142 23.016 1.09195C22.1019 1.63494 21.1014 2.01715 20.058 2.22196C19.3564 1.47282 18.4271 0.976281 17.4143 0.809429C16.4016 0.642577 15.3621 0.814746 14.4572 1.29921C13.5524 1.78367 12.8328 2.55332 12.4102 3.48866C11.9875 4.424 11.8855 5.4727 12.12 6.47195C10.2677 6.37895 8.45564 5.8975 6.80144 5.05886C5.14723 4.22022 3.68785 3.04312 2.51801 1.60396C2.11801 2.29396 1.88801 3.09396 1.88801 3.94596C1.88757 4.71295 2.07644 5.4682 2.43789 6.14469C2.79934 6.82118 3.32217 7.39799 3.96001 7.82396C3.22029 7.80042 2.49688 7.60054 1.85001 7.24095V7.30095C1.84994 8.3767 2.22204 9.41933 2.90319 10.252C3.58434 11.0846 4.53258 11.6559 5.58701 11.869C4.9008 12.0547 4.18135 12.082 3.48301 11.949C3.78051 12.8746 4.36001 13.684 5.14038 14.2639C5.92075 14.8438 6.86293 15.1651 7.83501 15.183C6.18484 16.4784 4.1469 17.181 2.04901 17.178C1.67739 17.1781 1.30609 17.1564 0.937012 17.113C3.06649 18.4821 5.54535 19.2088 8.07701 19.206C16.647 19.206 21.332 12.108 21.332 5.95195C21.332 5.75196 21.327 5.54995 21.318 5.34995C22.2293 4.69093 23.0159 3.87485 23.641 2.93995L23.643 2.93695Z",
    fill: "#699BF7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.4bee42bb11085258f7af267b63673353.svg";
export { ForwardRef as ReactComponent };